import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IncidentListCard } from '../../common/IncidentListCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const IncidentListCardWidget = (props) => {
    const component = useMemo(() => (_jsx(IncidentListCard, { viewObject: { matchedPrimary: props.contextCustomer, matchedRelatedByPk: undefined, matchedRelatedBySk: undefined }, contextCustomer: props.contextCustomer, user: props.user, userGroupRoles: props.userGroupRoles, userSelectedGroup: props.userSelectedGroup, roleArbitrationInstance: undefined, userFunctions: props.userFunctions, transactionFunctions: props.transactionFunctions, isSmallView: false })), [props.contextCustomer]);
    return {
        name: 'IncidentListCard',
        category: 'common',
        component,
    };
};
